import { all, call, put, select, takeLatest } from 'redux-saga/effects'
import { coreApi } from '../../../services/api'
import { RootState } from '../rootReducer'
import { PreferencesSuccess, PreferencesError } from './action'
import { DashboardTypes } from './types'

function* getPreferences() {
  try {
    const getToken = (state: RootState) => ({ token: state.auth.token, student: state.student })

    const { token, student } = yield select(getToken)

    if (token && student.profile._id) {
      const preferencesResponse = yield call(
        coreApi.get,
        `students/dashboard/preference/student/${student.profile._id}`
      )
      const courses = {}

      preferencesResponse.data?.courses.forEach((data) => {
        courses[data._id] = data
      })

      const data = { ...preferencesResponse.data, courses }
      yield put(PreferencesSuccess(data))
    }
  } catch (error) {
    yield put(PreferencesError({ error: error.response }))
  }
}

export default all([takeLatest(DashboardTypes.PREFERENCES_REQUEST, getPreferences)])
